import {useEffect} from 'react';
import delete_icon_red from "../../../../assets/vw/svg/eliminar_rojo.svg";

const CardContenido = ({infoCard, handleArchivar, setShowContent, getApp, localDateTimeToUTC, contextos}) => {

    let contexto = Object.entries(contextos).find((ctx) => ctx[1] === infoCard.original.contexto);

    useEffect(() => {
        return () => {
            setShowContent(false);
        }
    }, [setShowContent])

    return (
        <>
            <div className={"select-card-content mt-3 mt-sm-4"}>
                <div className={"d-flex"}>
                    <div className={"mr-4"}>
                        <div className="select-card-content-title">Nombre:</div>
                        <div className="select-card-content-description mb-3">
                            {!infoCard.original.nombre ? '-' : infoCard.original.nombre.length > 50
                                ? `${infoCard.original.nombre.substring(0, 50)}…`
                                : infoCard.original.nombre}
                        </div>
                    </div>
                    <div className={"ml-1"}>
                        <div className="select-card-content-title">Aplicación:</div>
                        <div className="select-card-content-description">
                            {!infoCard.original.appId ? '-' : getApp(infoCard.original.appId).length > 23 
                                ?`${getApp(infoCard.original.appId).substring(0, 20)}…` 
                                : getApp(infoCard.original.appId)
                            }
                        </div>
                    </div>
                    <div className={"ml-4"}>
                        <div className="select-card-content-title">Contexto:</div>
                        <div className="select-card-content-description">
                        {!contexto ? '-' : contexto[0]}
                        </div>
                    </div>
                </div>
                <div className="select-card-content-title">Fecha de inicio:</div>
                <div className="select-card-content-description">
                    {infoCard.original.fechaInicio ? localDateTimeToUTC(infoCard.original.fechaInicio) : '-'}
                </div>
            </div>
            <div className="select-card-footer d-flex justify-content-end">
                <div className={"d-flex align-items-end"}>
                    {/*<button*/}
                    {/*    className="button_icon-vw"*/}
                    {/*    type="button"*/}
                    {/*    onClick={() => editar({row: infoCard})}*/}
                    {/*>*/}
                    {/*    <div className="d-flex font-azul-claro-secundario">*/}
                    {/*        <div className={"editar-icon-mobile mr-2"}></div>*/}
                    {/*        Editar*/}
                    {/*    </div>*/}
                    {/*</button>*/}
                    <button
                        className="button_icon-vw mr-0"
                        type="button"
                        onClick={() => handleArchivar({row: infoCard})}
                    >
                        <div className="aling-icon-eliminar font-rojo-complementario">
                            {" "}
                            <img
                                src={delete_icon_red}
                                alt="archivar"
                                className="px-2"
                            ></img>{" "}
                            Eliminar
                        </div>
                    </button>
                </div>
            </div>
        </>
    )
}

export default CardContenido